export var SatisfactionRatingType;
(function (SatisfactionRatingType) {
    SatisfactionRatingType[SatisfactionRatingType["POSITIVE"] = 10] = "POSITIVE";
    SatisfactionRatingType[SatisfactionRatingType["NEUTRAL"] = 20] = "NEUTRAL";
    SatisfactionRatingType[SatisfactionRatingType["NEGATIVE"] = 30] = "NEGATIVE";
})(SatisfactionRatingType || (SatisfactionRatingType = {}));
export var ALL_SATISFACTION_RATINGS = [
    SatisfactionRatingType.NEGATIVE,
    SatisfactionRatingType.NEUTRAL,
    SatisfactionRatingType.POSITIVE,
];
export var CsatChannel;
(function (CsatChannel) {
    CsatChannel[CsatChannel["API_EMAIL_HELP_CENTER"] = 10] = "API_EMAIL_HELP_CENTER";
    CsatChannel[CsatChannel["CALL_CENTER"] = 20] = "CALL_CENTER";
    CsatChannel[CsatChannel["CHAT"] = 30] = "CHAT";
    CsatChannel[CsatChannel["FACEBOOK"] = 40] = "FACEBOOK";
    CsatChannel[CsatChannel["WHATSAPP"] = 50] = "WHATSAPP";
    CsatChannel[CsatChannel["SMS"] = 60] = "SMS";
    CsatChannel[CsatChannel["TWITTER"] = 80] = "TWITTER";
    CsatChannel[CsatChannel["INSTAGRAM"] = 90] = "INSTAGRAM";
})(CsatChannel || (CsatChannel = {}));
export var CsatStatus;
(function (CsatStatus) {
    CsatStatus[CsatStatus["WAITING"] = 10] = "WAITING";
    CsatStatus[CsatStatus["CANCELED"] = 20] = "CANCELED";
    CsatStatus[CsatStatus["SUBMITTED"] = 30] = "SUBMITTED";
})(CsatStatus || (CsatStatus = {}));
//# sourceMappingURL=index.js.map